define.alias("shared/components/shared/profile-categorization/categorize-steps", "settings/components/shared/profile-categorization/categorize-steps");